// extracted by css-extract-rspack-plugin
export default {"surveyToast":"vD5RCaT6xPImpL4n","dismissButton":"jVD33IltngUkEoDy"};